import React from 'react'
import WhatsappSessionPreview from './WhatsappSessionPreview'

export default function WhatsappContentSessionPreviewAdapter({ formData, context }) {
  const fromDef = context && context.formDefinition && context.formDefinition.waContentPreview
  const session = (fromDef && typeof fromDef === 'object') ? fromDef : (formData || {})
  return <WhatsappSessionPreview formData={session} context={context} />
}
